import { DUPE_API_URL } from '@dupe/common/constants'
import { useQuery } from '@tanstack/react-query'
import useAuthUser from '~/src/hooks/useAuthUser'
import useGetTempUserId from '~/src/hooks/useGetTempUserId'
import fetcher from '~/src/lib/fetcher'

type ApiResponse = {
  dupesCount: number
  chatsCount: number
  recentsCount: number
  tempUserId: string
}

interface Props {
  enabled?: boolean
}

const useFetchAnonymousRecentsCount = ({ enabled }: Props) => {
  const { authUser, loading: loadingAuthUser } = useAuthUser()
  const { tempUserId } = useGetTempUserId()
  const fetchUrl = `${DUPE_API_URL}/api/anonymous-recents-count`

  const loading = loadingAuthUser

  return useQuery<ApiResponse, Error>({
    queryKey: ['anonymous-recents-count', tempUserId],
    queryFn: () =>
      fetcher<ApiResponse>(fetchUrl, {
        method: 'GET',
        tempUserId,
      }),
    enabled: enabled && !authUser && !loading,
  })
}

export default useFetchAnonymousRecentsCount
